import { css } from "@linaria/core";

import { pm2Boundaries } from "@pm2/design-tokens";
import { breakpoints, units } from "@ui/css";
import { colors, surfaces, typographies } from "@ui/kit";
import { postloadedImageSelectors } from "@utils/react";

export const section = css`
  position: relative;

  margin-inline: ${pm2Boundaries.container.offsetLeft({ scale: -1 })}
    ${pm2Boundaries.container.offsetRight({ scale: -1 })};
  padding-inline: ${pm2Boundaries.container.offsetLeft()}
    ${pm2Boundaries.container.offsetRight()};
  padding-top: ${units.px(60)};
  padding-bottom: ${units.px(105)};

  background: ${surfaces.primary({ alpha: 0.9 })};

  overflow: hidden;

  display: flex;
  align-items: flex-start;
  gap: ${units.px(30)} ${units.px(55)};

  @media ${breakpoints.mobile.andDown().toQuery()} {
    padding-top: ${units.px(40)};
    padding-bottom: ${units.px(65)};

    flex-direction: column;
  }
`;

export const image = css`
  flex-basis: 50%;

  & ${postloadedImageSelectors.image()} {
    height: auto;
    border-radius: ${units.px(4)};
  }

  @media ${breakpoints.mobile.andDown().toQuery()} {
    width: 100%;
    order: 2;
  }
`;

export const content = css`
  max-width: ${units.px(700)};
  flex-basis: 50%;
`;

export const label = css`
  margin-top: ${units.px(-3)};
  margin-bottom: ${units.px(5)};

  font-family: ${typographies.meta()};
`;

export const heading = css`
  hyphens: auto;
  word-break: break-word;

  font-family: ${typographies.heading1()};
  text-wrap: pretty;
`;

export const body = css`
  ${colors.interactiveText.link
    .__override({
      hover: surfaces.primary.default.color,
      active: surfaces.primary.default.color,
    })
    .toString()};

  margin-block: ${units.px(20)};

  @media ${breakpoints.mobile.andDown().toQuery()} {
    margin-top: 0;
  }
`;

export const mobileContent = css`
  order: 3;
`;

export const backdrop = css`
  position: absolute;
  inset: 0;
  z-index: -1;

  filter: blur(18px);
`;

export const graphic = css`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;

  color: #fff;
`;
